import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import {
  DatastorePortfoliosModule,
  DatastoreSkillsModule,
} from '@freelancer/datastore/collections';
import { DirectivesModule } from '@freelancer/directives';
import { TrackingModule } from '@freelancer/tracking';
import { UiModule } from '@freelancer/ui';
import { UserProfileLoggedOutLinkModule } from '../../../../user-profile/user-profile-logged-out-link/user-profile-logged-out-link.module';
import { UserPortfolioItemCardComponent } from './user-portfolio-item-card/user-portfolio-item-card.component';
import { UserPortfolioItemOverlayModule } from './user-portfolio-item-overlay/user-portfolio-item-overlay.module';
import { UserPortfolioComponent } from './user-portfolio.component';

@NgModule({
  imports: [
    CommonModule,
    DatastorePortfoliosModule,
    DatastoreSkillsModule,
    DirectivesModule,
    TrackingModule,
    UiModule,
    UserPortfolioItemOverlayModule,
    DatastorePortfoliosModule,
    UserProfileLoggedOutLinkModule,
  ],
  declarations: [UserPortfolioComponent, UserPortfolioItemCardComponent],
  exports: [UserPortfolioComponent],
})
export class UserPortfolioModule {}
